export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5288.f6c1acb2.jpg";